import api from '@/api/fetchClient'

export default {
  getCategories(params = {}) {
    let url = 'categories'
    const queryParams = []

    if (params.search) {
      queryParams.push(`search=${encodeURIComponent(params.search)}`)
    }

    if (queryParams.length > 0) {
      url += '?' + queryParams.join('&')
    }

    return api.get(url, { authorized: true })
  },

  getCategoryById(id) {
    return api.get(`categories/${id}`, { authorized: true })
  },

  createCategory(payload) {
    return api.post('categories', payload, { authorized: true })
  },

  updateCategory(id, payload) {
    return api.put(`categories/${id}`, payload, { authorized: true })
  },

  deleteCategory(id) {
    return api.delete(`categories/${id}`, { authorized: true })
  }
}
